// IMPORT PACKAGE REFERENCES

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// IMPORT PROJECT REFERENCES

import PharmacyListItem from './PharmacyListItem';
import { PharmacySidebar } from './PharmacySidebar';


// COMPONENT

const renderList = pharmacies => (
    pharmacies.map(pharmacy => renderListItem(pharmacy))
);

const renderListItem = pharmacy => (
    <PharmacyListItem key={pharmacy.id} pharmacy={pharmacy} />
);

const PharmacyList = (props) => (
    <div className="container filled">
           <div className="row">
           <div className="col-sm-3">
                <PharmacySidebar />
           </div>
           <div className="col-sm-9">
                { props.pharmacies.length === 0 && <div className="empty-placeholder">No pharmacies</div>}
                {renderList(props.pharmacies)}
           </div>
           </div>
        
    </div>
);

PharmacyList.propTypes = {
    pharmacies: PropTypes.array.isRequired
};

export { PharmacyList };